import { IChainTokenStat } from 'app-lib/apis/bzxApi'
import React from 'react'
import ReserveDesktopItem from './ReserveDesktopItem'

export default function ReserveDesktop({ statsItems }: { statsItems: IChainTokenStat[] }) {
  return (
    <div className="overflow-x-auto">
      <table className="table--padded-1 table--default" cellSpacing="0">
        <thead>
          <tr>
            <th className="table__head txt-left">Reserve</th>
            <th className="table__head txt-left">TVL (USD)</th>
            <th className="table__head txt-left">Total Supply</th>
            <th className="table__head txt-left">Liquidity</th>
            <th className="table__head txt-left">
              Locked as
              <br />
              Collateral
            </th>
            <th className="table__head txt-left">
              Lending <br />
              Rates
            </th>
            <th className="table__head txt-left">
              Borrowing <br />
              Rates
            </th>
          </tr>
        </thead>

        {statsItems.map((item) => (
          <ReserveDesktopItem key={item.tokenName} statsItem={item} />
        ))}
      </table>
    </div>
  )
}
